import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { Header } from "./Header";

const HeaderConnector = ({
	data,
	locale,
	headerMenu,
	headerNavigation,
	altLangPages,
	alerts,
	pageType,
	logoOnly,
	className,
}) => {
	const pageHeader = headerNavigation || data.defaultHeader;
	const pageMenu = headerMenu || data.defaultMenu;

	const displayLogoOnly = logoOnly || pageHeader?.displayLogoOnly;

	return (
		<Header
			logo={
				pageHeader?.logo?.[0]?.format === "svg"
					? pageHeader?.logo?.[0]?.original_secure_url
					: pageHeader?.logo?.[0]?.secure_url
			}
			logoLink={pageHeader?.logoLink?.slug}
			links={pageHeader?.links}
			ctaMessageLink={pageHeader?.ctaMessageLink}
			menuTitle={pageMenu?.displayTitle}
			menuLinks={pageMenu?.menuItems}
			locale={locale}
			altLangPages={altLangPages}
			homepagePaths={data.homepagePaths}
			logoOnly={displayLogoOnly}
			widget={pageHeader?.widget}
			alerts={alerts}
			travelAlertsUrl={data.travelAlertsUrl?.path}
			pageType={pageType}
			className={className}
		/>
	);
};
export default HeaderConnector;
export { HeaderConnector };

HeaderConnector.propTypes = {
	data: PropTypes.shape({
		defaultHeader: PropTypes.any,
		defaultMenu: PropTypes.any,
		homepagePaths: PropTypes.any,
		travelAlertsUrl: PropTypes.any,
	}).isRequired,
	locale: PropTypes.any,
	headerMenu: PropTypes.any,
	headerNavigation: PropTypes.any,
	altLangPages: PropTypes.shape({
		edges: PropTypes.arrayOf(
			PropTypes.shape({
				node: PropTypes.shape({
					context: PropTypes.shape({
						id: PropTypes.string,
						locale: PropTypes.string,
					}),
					path: PropTypes.string,
				}),
			})
		),
	}).isRequired,
	alerts: PropTypes.any,
	pageType: PropTypes.any,
	logoOnly: PropTypes.any,
	className: PropTypes.any,
};

HeaderConnector.defaultProps = {
	locale: "en_CA",
	headerMenu: false,
	headerNavigation: false,
	alerts: undefined,
	pageType: undefined,
	logoOnly: false,
	className: undefined,
};

export const query = graphql`
	query GetDefaultLocalizedHeader($locale: String!) {
		defaultHeader: contentfulHeaderNavigation(
			contentful_id: { eq: "2MoEQTIXxkmz4H10yr5mek" }
			node_locale: { eq: $locale }
		) {
			...headerNavigation
		}
		defaultMenu: contentfulHeaderMenu(
			contentful_id: { eq: "5QGz7hjBVdhxT9IpwllyMU" }
			node_locale: { eq: $locale }
		) {
			...headerMenu
		}
		homepagePaths: allSitePage(filter: { context: { template: { eq: "homepage" } } }) {
			edges {
				...homepagePaths
			}
		}
		travelAlertsUrl: sitePage(context: { template: { eq: "alerts" }, locale: { eq: $locale } }) {
			path
		}
	}
`;
